export default class SukuColorButton extends HTMLElement {
  static get observedAttributes() {
    return ['active', 'color', 'image', 'available', 'border']
  }

  constructor() {
    super()

    this.addEventListener('click', this.handleClick.bind(this))
  }

  connectedCallback() {
    this.available = this.getAttribute('available') === 'true' ? true : false
    this.active = this.getAttribute('active') === 'true' ? true : false
    this.border = this.getAttribute('border')
    this.color = this.getAttribute('color')
    this.raw = this.getAttribute('raw')
    this.name = this.getAttribute('name')
    this.image = this.getAttribute('image')
    this.texture = this.getAttribute('texture')
    this.textureStyle = this.getAttribute('texture-style')
    this.textureAlt = this.getAttribute('texture-alt')

    this.closeIcon = `
      <div class="absolute w-[120%] h-[120%] top-[-10%] left-[-10%] flex items-center justify-center text-[grey] opacity-80">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1" stroke="currentColor" class="w-[100%] h-[100%]">
      <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
      </svg>
      </div>
    `
    this.className = 'w-[48px] h-[48px] rounded-full flex bg-grey mr-4 mb-4 bg-cover relative mobile:w-[40px] mobile:h-[40px] mobile:mr-2.5 after:content-[""] after:absolute after:top-[-4px] after:bottom-[-4px] after:left-[-4px] after:right-[-4px] after:border-2 after:border-transparent after:rounded-full'
    if (this.border !== 'false') {
      this.classList.add('border')

      this.style.borderColor = this.border
    }
    
    this.style.backgroundImage = `url('${this.image}')`
    
    if (!this.available) {
      this.innerHTML = this.closeIcon
    }
  }

  handleClick(evt) {
    if (!this.available) {
      // return
    }

    this.dispatchEvent(new CustomEvent('update', { bubbles: true, detail: { key: 'color', value: this.color } }))

    this.dispatchEvent(new CustomEvent('color', { bubbles: true, detail: { color: this.color, name: this.name, texture: this.texture, style: this.textureStyle, alt: this.textureAlt } }))
  }

  toggle() {
    if (this.active) {
      this.classList.add('after:border-[grey]')
    } else {
      this.classList.remove('after:border-[grey]')
    }
  }

  update() {
    if (this.available) {
      this.innerHTML = ''
    } else {
      this.innerHTML = this.closeIcon
    }
  }

  attributeChangedCallback(name, current, value) {
    if (current === value) {
      return
    }

    switch (name) {
      case 'active' :
        this.active = value === 'true' ? true : false

        this.toggle()
        break
      case 'available' :
        this.available = value === 'true' ? true : false

        // this.update()
        break
    }
  }
}

customElements.define('suku-color-button', SukuColorButton)
